var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f5f5f5","padding":"1rem"}},[_c('VuePerfectScrollbar',{staticStyle:{"height":"calc(100dvh - 6rem)","background-color":"#f5f5f5"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }